type StringKey<D> = Extract<keyof D, string>;

type IdType<D> = StringKey<D> | string;

interface SortingRule<D> {
    id: IdType<D>;
    desc?: boolean | undefined;
}

export type RawSortBy<D = Record<any, any>> = SortingRule<D>[];

export function createSortByQueryParam(
    rawSortBy: RawSortBy,
    defaultParameter?: string,
    uppercase = true,
) {
    const field = rawSortBy[0]?.id || '';
    const currentSort = uppercase ? field.toUpperCase() : field;

    if (!currentSort) {
        return defaultParameter;
    }

    return rawSortBy[0]?.desc ? `${currentSort},desc` : `${currentSort},asc`;
}
